<template>
  <div class="single-view landing">
   <video class="inner setResolution autoplay" preload="none" loop playsinline muted autoplay is-playing="false" data-object-fit="cover" hasaudio="false" style="width: 100%; height: 100%; -o-object-fit: cover; object-fit: cover; background-color: #000;">
        <source src="https://videos.quammbase.it/download/streaming-playlists/hls/videos/db75d7d7-3dbb-4f98-b287-af4a4a5ccb0f-1080-fragmented.mp4">
        <source src="https://videos.quammbase.it/download/streaming-playlists/hls/videos/db75d7d7-3dbb-4f98-b287-af4a4a5ccb0f-720-fragmented.mp4" media="all and (max-width:1280px)">
        <source src="https://videos.quammbase.it/download/streaming-playlists/hls/videos/db75d7d7-3dbb-4f98-b287-af4a4a5ccb0f-360-fragmented.mp4" media="all and (max-width:640px)">
      </video>
    <div class="landing__animation">
      <div class="landing__animation__static">
        <span>Pololab: laboratorio avanzato per </span><span>l'analisi di vino e prodotti agroalimentari.</span>
      </div>
    </div>

    <router-link
      class="landing__cta"
      :to="{ name: 'home' }"
      @mouseover.native="updateMouseCursor('button')"
      @mouseout.native="updateMouseCursor('default')">
      Entra nel sito
    </router-link>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapMutations } from 'vuex'

export default {
  data: () => ({
    timer: 1.5 * 1000,
    wordCount: 0,
    maxSeenWords: 5,
    ticker: undefined,
    currentListElement: 0,
    rossettoList: [
      'GBR',
      'vivido',
      'deciso',
      'concreto',
      'raffinato',
      'nuovo',
      'green',
      'passione',
      'ufficio',
      'prodotti',
      'soluzioni',
      'noleggio'
    ]
  }),
  mounted () {
    /* document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.$_pauseAnimation()
      else this.$_startAnimation()
    })

    this.$_startAnimation() */
  },
  beforeDestroy () {
    this.$_pauseAnimation()
  },
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ]),
    $_startAnimation () {
      if (typeof this.ticker !== 'undefined') return

      this.ticker = window.setInterval(() => {
        this.currentListElement = this.$_fixedRandom(0, this.rossettoList.length - 1, this.currentListElement)
      }, this.timer)
    },
    $_pauseAnimation () {
      window.clearInterval(this.ticker)
      this.ticker = undefined
    },
    $_fixedRandom (from, to, exclude) {
      const random = _.random(from, to, false)
      return random === exclude ? this.$_fixedRandom(from, to, exclude) : random
    }
  },
  watch: {
    currentListElement: {
      handler () {
        this.wordCount = this.wordCount + 1
      }
    },
    wordCount: {
      handler (value) {
        if (value >= this.maxSeenWords) this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style lang="scss">

@import '../assets/scss/breakpoint.scss';

$white: #f2f2f2;
$violet: #0b3277;

$marginLeftRight: 6.25%;
$marginLeftRightDesktop: 6.5%;

$dynamicTextMargin: 5rem;

$ctaLeftRight: 6.25%;
$barCtaWidth: 2.5rem;
$barCtaWidthDesktop: 5rem;

$marginCtaLeftRight: 6.25%;
$marginCtaLeftRightDesktop: 3.25%;
$marginCtaTopBottomDesktop: 3.25%;

.landing {
  display: flex;
  background-color: #0487a3;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;

  .global-navigation__anniversario {
    transition: opacity .1s;
  }

  &.default-enter-active, &.reverse-enter-active, &.default-leave-active, &.reverse-leave-active {
    .global-navigation__anniversario {
      opacity: 0;
    }
  }

  video {
    position: absolute;
    width: 100%;
    height: 100vh;
  }
}

.landing__animation {
  box-sizing: border-box;
  padding: 0 $marginLeftRight;
  color: $white;
  font-size: 4.5rem;
  position: relative;

  @include media(">=large"){
    font-size: 4.5rem;
    padding: 0 $marginLeftRightDesktop;
    height: 100vh;
    align-items: center;
  }

  @include media(">=xlarge"){
    font-size: 6rem;
  }

}

.landing__cta{
  position: fixed;
  cursor: pointer;
  z-index: 110;
  font-size: 1.6rem;
  color: $white;
  text-decoration: none;

  right: $marginCtaLeftRight;
  bottom: $marginCtaLeftRight;

  @include media(">=medium"){
    left: auto;
    top: auto;
    right: $marginCtaLeftRightDesktop;
    bottom: $marginCtaTopBottomDesktop;
    transform: none;
  }
  @include media(">=xlarge"){
    font-size: 1.8rem;
  }

}

.landing__cta::after{
  content: "";
  display: inline-block;
  background: $white;
  width: $barCtaWidth;
  margin-left: 2rem;
  height: 1px;
  transform: scaleX(1);
  transform-origin: left;
  transition: transform .3s;
  @include media(">=medium"){
    width: $barCtaWidthDesktop;
  }

}
.landing__cta:hover::after{
  transform-origin: left;
  transform: scaleX(.75);
}

/* @group Animation */

.landing__animation {
  display: flex;
  width: 100%;
}

.landing__animation__static {
  line-height: 1;
  z-index: 999;

  @include media(">=large"){
    line-height: 1.4;
  }

  span {
    line-height: 5rem;
    text-shadow: 0px 0px 20px rgba(0,0,0,0.3);

    @include media(">=large"){
      display: block;
      line-height: 7rem;
    }
  }
}

.landing__animation__static__wrapper {
  margin-left: $dynamicTextMargin;

  position: absolute;
  transform: translateY(100%);
  height: 6rem;
  left: 0;
  margin-left: 6.25%;

  @include media(">=medium"){
    transform: translateY(100%);
  }

  @include media(">=large"){
    position: relative;
    transform: translateY(0);
    margin-left: 4.5rem;
    height: auto;
  }
}

.landing__animation__dynamic__element {
  line-height: 2.4;
  color: $violet;

  @include media(">=large") {
    position: absolute;
    transform: translateY(-50%);
  }
}

.slide-fade-enter {
  opacity: 0;
  transform: translateX(-100%);

  @include media(">=large") {
    transform: translateY(-200%);
  }
}

.slide-fade-enter-to {
  opacity: 1;
  transform: translateX(0%);

  @include media(">=large") {
    transform: translateY(-50%);
  }
}

.slide-fade-enter-active, .slide-fade-leave-active {
  position: absolute;
  transition: all 1s;
}

.slide-fade-leave {
  opacity: 1;
  transform: translateX(0%);

  @include media(">=large") {
    transform: translateY(-50%);
  }
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(100%);

  @include media(">=large") {
    transform: translateY(100%);
  }
}

/* @end */
</style>
